import React from 'react';
import styles from './Expirations.module.scss';
import { IExpirationGroups, IExpirationItem } from './utils';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

interface ExpirationsTableProps {
    data: IExpirationGroups;
}

const ExpirationsTable: React.FC<ExpirationsTableProps> = ({ data }) => {

    const renderGroup = (items: IExpirationItem[], title: string, variant: 'expired' | 'warning' | 'info' | 'normal') => {
        if (!items || items.length === 0) return null;

        return (
            <React.Fragment key={title}>
                <tr className={classNames(styles.groupHeaderRow, styles[`group_${variant}`])}>
                    <td colSpan={4} className={styles.groupHeaderCell}>
                        {title} ({items.length})
                    </td>
                </tr>
                {items.map((item, index) => {
                    const daysLeft = item.daysLeft === 0 ? 'Today' : item.daysLeft > 0 ? item.daysLeft : 'Expired';
                    return (
                        <tr key={`${item.deviceId}-${index}`}>
                            <td><Link to={`/device/${item.deviceId}`}>{item.vehicleName}</Link></td>
                            <td>{item.itemName}</td>
                            <td>{item.expireDate}</td>
                            <td className={classNames(styles.daysLeft, styles[`text_${variant}`])}>
                                {daysLeft}
                            </td>
                        </tr>
                    );
                })}
            </React.Fragment>
        );
    };

    return (
        <div className={styles.tableWrapper}>
            <table className={styles.table}>
                <thead>
                    <tr>
                        <th>Vehicle Name</th>
                        <th>Type</th>
                        <th>Expiration Date</th>
                        <th>Days Left</th>
                    </tr>
                </thead>
                <tbody>
                    {renderGroup(data.expired, 'Expired', 'expired')}
                    {renderGroup(data.days30, 'Expires in 30 Days', 'warning')}
                    {renderGroup(data.days60, 'Expires in 60 Days', 'info')}
                    {renderGroup(data.days90, 'Expires in 90 Days', 'normal')}
                </tbody>
            </table>
        </div>
    );
};

export default ExpirationsTable;